import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { Contact } from '../../../Models/Contact';

export default function ClientContactListTable({
  data,
  deleteContact,
  editContact,
}: {
  data: Contact[];
  deleteContact(id: number): void;
  editContact: (feature: Contact) => void;
}) {
  const columnHelper = createColumnHelper<Contact>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editContact(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteContact(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.firstName, {
      id: 'firstName',
      header: 'First',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: 'lastName',
      header: 'Last',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.phone, {
      id: 'phone',
      header: 'Phone',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.email, {
      id: 'email',
      header: 'Email',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'id',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
